import React, { useEffect, useRef } from "react";
import StatusCard from "./StatusCard";
import { useTheme } from "@mui/styles";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: { display: "flex", flexDirection: "column" },
});

const ApplyError = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const componentName = "ApplyError";
  const translation = useTranslation(pathname, componentName);
  const { img, title, description, background } = translation;

  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement) {
      focusOnElement();
    }
  });

  return (
    <>
      <Box sx={classes.container} ref={focusElement}>
        <StatusCard
          img={img.src}
          background={background.src}
          msg={title}
          description={description}
        />
      </Box>
    </>
  );
};

export default ApplyError;
